import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=a6533eea&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6533eea')) {
      api.createRecord('a6533eea', component.options)
    } else {
      api.reload('a6533eea', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=a6533eea&", function () {
      api.rerender('a6533eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24iEPK75OUbSs/JS/comp/IncreaseNumber.vue"
export default component.exports